import './_helpers.js';

import './components/_autocomplete.v2.js';
import './components/_carousel.js';
import './components/_filter.js';
import './components/_footer.js';
import './components/_login.js';
import './components/_masonry-grid.js';
import './components/_menu.js';
import './components/_nav.v2.js';
import './components/_onboarding.js';
import './components/_prize.js';
import './components/_tabs.js';
import './components/_ticker.js';
import './components/_videos.js';

import './animation/_helpers.js';
import './animation/area.js';
import './animation/foyer.js';
import './animation/help.js';
import './animation/login.js';
import './animation/onboard.js';
import './animation/vip.js';

import './transitions/_helpers.js';
import './transitions/barba.js';
import './transitions/default.js';
// import './transitions/categories.js';
import './transitions/category-right.js';
import './transitions/category-left.js';
import './transitions/down.js';
import './transitions/up.js';
